<template>
    <div
        @click.prevent="toggled = !toggled"
        :class="[toggled ? 'bg-emerald-500' : 'bg-gray-400']"
        class="w-12 h-8 rounded-full border-2 border-transparent transition-all duration-300 ease-in-out hover:cursor-pointer"
    >
        <div
            :class="[toggled ? 'ml-4' : 'ml-0']"
            class="h-7 w-7 rounded-full bg-white"
            style="transition: inherit;"
        >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    computed: {
        toggled: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    }
}
</script>
